module.exports = __webpack_public_path__ + "static/media/110-guinea.3b08f19f.svg";